import * as React from 'react';
import { UIComponentState } from '../../../toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { GridComponent, GridComponentProps } from '../../../toolkit/grid/gridcomponent';
import { TabViewModelImpl } from '../../../toolkit/tabs/tab/tabviewmodel';
import { ListViewModel } from '../../../toolkit/horizontallist/listviewmodel';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import './flash-message-style.css';
import { FlashMessageListCSSStyle, FlashMessageListCSSStyleImpl } from './flasmessagelistcss';
import { FlashMessageDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';

export class FlashMessageDefaultTabViewModelImpl extends TabViewModelImpl
{
    private ref: GridComponent<GridComponentProps<FlashMessageDto>, UIComponentState>;
    private cssStyle: FlashMessageListCSSStyle;
   
    constructor(private context: BaseContext, 
        private listViewModel: ListViewModel<FlashMessageDto>, private title: string)
    {
        super();

        this.cssStyle = new FlashMessageListCSSStyleImpl(context);
    }

    getTabView(): JSX.Element
    {  
        return (
         <>
          <div id="flash-message-wrapper">
                                {
                                    this.getWebView()
                                }
                    </div>
                {/* <div id="flash-message-col-wrapper">
                                {
                                    this.getMobileView()
                                }
                </div> */}
            <div id="flash-messages-wrapper-carddiv-default">
             <GridComponent ref={(item: any) => this.ref = item} listViewModel={this.listViewModel} context={this.context}/>
            </div>
         </>);

    }

    getWebView()
    {
        return (
            <>
            <div id="flash-message-main-div" style={{}}>
                <div id="flash-message-tab-title-div" style={{}}>
                <label id="flash-message-tab-title-label" style={this.cssStyle.getTitleCSSStyle()}>{this.context.getResources().getString(Strings.default_flash_message)}</label>
                </div>
                {/* {this.isShowMore && <div  style={{flex: 0.5,cursor:'pointer', textAlign: "right", justifyContent: "flex-end"}}>
                    <label id="flash-message-showmore-label" onClick={this.showMore} style={this.cssStyle.getShowMoreCSSStyle()}>{this.context.getResources().getString(Strings.show_more)}</label>
                </div>}
                {!this.isShowMore && <div  style={{flex: 0.5, cursor:'pointer', textAlign: "right", justifyContent: "flex-end"}}>
                    <label id="flash-message-showmore-label" onClick={this.showLess} style={this.cssStyle.getShowMoreCSSStyle()}>{this.context.getResources().getString(Strings.show_less)}</label>
                </div>} */}
            </div>
            </>
        );
    }

    getMobileView()
    {
        return (
            <>
            <div style={{display: "flex", flexFlow: "row wrap", width: "100%"}}>
                <div style={{flex: 0.8, textAlign: "left", justifyContent: "flex-start"}}>
                <label style={this.cssStyle.getMobileTitleCSSStyle()}>{this.context.getResources().getString(Strings.default_flash_message)}</label>
                </div>
                {/* {this.isShowMore && <div style={{flex: 0.5,cursor:'pointer',  textAlign: "right", justifyContent: "flex-end"}}>
                    <label onClick={this.showMore} style={this.cssStyle.getMobileShowMoreCSSStyle()}>{this.context.getResources().getString(Strings.show_more)}</label>
                </div>}
                {!this.isShowMore && <div style={{flex: 0.5, cursor:'pointer', textAlign: "right", justifyContent: "flex-end"}}>
                    <label onClick={this.showLess} style={this.cssStyle.getMobileShowMoreCSSStyle()}>{this.context.getResources().getString(Strings.show_less)}</label>
                </div>} */}
            </div>
            </>
        );
    }
    
    updateTabData(listOfDatas: FlashMessageDto[], isShowMore: boolean, scrollToPosition: number, isScrollToPositionRequired: boolean)
    {
        this.listViewModel.setListDatas(listOfDatas);
        this.listViewModel.setScrollToPosition(scrollToPosition,isScrollToPositionRequired);
        this.ref !== null && this.ref !== undefined && this.ref.forceUpdateComponent();
    }

    getTitle(): string 
    {
        return this.title;
    }
    deleteData(id: string)
    {
        this.listViewModel.deleteData(id);

        this.ref !== null && this.ref.forceUpdateComponent();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagedefaulttabviewmodel.tsx